import * as React from 'react'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Alert, Box, Checkbox, FormControlLabel, FormGroup, MenuItem, Snackbar } from '@mui/material'
import theme from '../theme'
import api from '../services/api'

const defaultItem = {
  cod_empresa: '',
  url: '',
  auth_type: 'none',
  username: '',
  password: '',
  api_key: '',
  index_pattern: 'wazuh-alerts-*',
  min_level: 4,
  resolve_timeout: 30,
  verify_ssl: true,
  active: true,
  info: '',
}

export default function FormDialog(props) {
  const [handlerSnack, setHandlerSnack] = React.useState(false)
  const [msgSnack, setMsgSnack] = React.useState('')
  const [sevSnack, setSevSnack] = React.useState('success')
  const [state, setState] = React.useState({ ...defaultItem })

  const handleChange = (event) => {
    setState({ ...state, [event.target.name]: event.target.value })
  }

  const handleChangeCheck = (event) => {
    setState({ ...state, [event.target.name]: event.target.checked })
  }

  React.useEffect(() => {
    getEditInfo()
  }, [props.open, handlerSnack])

  const getEditInfo = () => {
    setState({ ...defaultItem })
    if (!props.id || !props.open) return
    api.get(`api_wazuh_es/find/${props.id}`)
      .then(res => setState(res.data.__data__ || res.data))
      .catch(() => setState({ ...defaultItem }))
  }

  const showNotify = (msg, sev = "success") => {
    setMsgSnack(msg)
    setSevSnack(sev)
    setHandlerSnack(true)
  }

  const handleSubmit = (event) => {
    event.preventDefault()
    const handlerClose = () => props.handlerClose()

    if (!props.id) {
      api.post('api_wazuh_es/create', state)
        .then(() => {
          showNotify("Registro adicionado com sucesso.")
          handlerClose()
        })
        .catch(() => showNotify("Um erro ocorreu...", 'error'))
    } else {
      api.put(`api_wazuh_es/edit/${props.id}/`, state)
        .then(() => {
          showNotify("Registro editado com sucesso.")
          handlerClose()
        })
        .catch(() => {
          handlerClose()
          showNotify("Um erro ocorreu...", 'error')
        })
    }
  }

  return (
    <div>
      <Snackbar
        open={handlerSnack}
        autoHideDuration={6000}
        onClose={() => setHandlerSnack(false)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert onClose={() => setHandlerSnack(false)} severity={sevSnack || 'error'} sx={{ width: '100%' }}>
          {msgSnack}
        </Alert>
      </Snackbar>
      <Dialog open={props.open} fullWidth maxWidth="sm">
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <DialogTitle>
            {!props.id ? 'Criar Config Wazuh/ES' : 'Editar Config Wazuh/ES'}
          </DialogTitle>
          <DialogContent>
            <TextField
              required
              autoFocus
              margin="dense"
              name="cod_empresa"
              label="Empresa (cod_empresa)"
              type="number"
              fullWidth
              value={state.cod_empresa}
              onChange={handleChange}
              variant="outlined"
              size="small"
            />
            <TextField
              required
              margin="dense"
              name="url"
              label="URL do Elasticsearch"
              type="text"
              fullWidth
              value={state.url}
              onChange={handleChange}
              variant="outlined"
              size="small"
            />
            <TextField
              select
              margin="dense"
              name="auth_type"
              label="Tipo de Autenticacao"
              fullWidth
              value={state.auth_type}
              onChange={handleChange}
              variant="outlined"
              size="small"
            >
              <MenuItem value="none">Nenhuma</MenuItem>
              <MenuItem value="basic">Basic (usuario/senha)</MenuItem>
              <MenuItem value="apikey">API Key</MenuItem>
            </TextField>

            {state.auth_type === 'basic' && (
              <>
                <TextField
                  margin="dense"
                  name="username"
                  label="Usuario"
                  type="text"
                  fullWidth
                  value={state.username}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
                <TextField
                  margin="dense"
                  name="password"
                  label="Senha"
                  type="password"
                  fullWidth
                  value={state.password}
                  onChange={handleChange}
                  variant="outlined"
                  size="small"
                />
              </>
            )}

            {state.auth_type === 'apikey' && (
              <TextField
                margin="dense"
                name="api_key"
                label="API Key"
                type="text"
                fullWidth
                value={state.api_key}
                onChange={handleChange}
                variant="outlined"
                size="small"
              />
            )}

            <TextField
              margin="dense"
              name="index_pattern"
              label="Index Pattern"
              type="text"
              fullWidth
              value={state.index_pattern}
              onChange={handleChange}
              variant="outlined"
              size="small"
            />
            <TextField
              margin="dense"
              name="min_level"
              label="Nivel Minimo (rule.level)"
              type="number"
              fullWidth
              value={state.min_level}
              onChange={handleChange}
              variant="outlined"
              size="small"
            />
            <TextField
              margin="dense"
              name="resolve_timeout"
              label="Timeout de Resolucao (minutos)"
              type="number"
              fullWidth
              value={state.resolve_timeout}
              onChange={handleChange}
              variant="outlined"
              size="small"
            />
            <TextField
              margin="dense"
              name="info"
              label="Informacoes adicionais"
              type="text"
              fullWidth
              value={state.info}
              onChange={handleChange}
              variant="outlined"
              size="small"
            />
            <FormGroup>
              <FormControlLabel
                sx={{ ml: 1, mt: 1 }}
                control={<Checkbox checked={state.verify_ssl} onChange={handleChangeCheck} name="verify_ssl" />}
                label="Verificar SSL"
              />
              <FormControlLabel
                sx={{ ml: 1 }}
                control={<Checkbox checked={state.active} onChange={handleChangeCheck} name="active" />}
                label="Ativo"
              />
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button sx={{ color: theme.palette.text.primary }} onClick={props.handlerClose}>Cancelar</Button>
            <Button sx={{ color: theme.palette.text.primary }} type="submit">
              {!props.id ? 'Adicionar' : 'Editar'}
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </div>
  )
}
